export default __webpack_public_path__ + "static/casablanca-8a7339b390c7a9c7a23d1232a2b1021c.png";